export enum INLINE_ACTIONS {
  SEARCH = 'search',
  INCIDENTS = 'incidents',
}
